import { useFormik } from "formik";
import styled from "styled-components";
import { shallowEqual } from "react-redux";
import { Contractor } from "../../../../../../services/subcontractor/get-all/types";
import { useMutation } from "@tanstack/react-query";
import * as yup from "yup";
import { StyledButton } from "../../../../../../components/Button/button";
import { theme } from "../../../../../../helpers/theme";
import { Input } from "../../../../../../components/Input/input";
import { RequiredInfo } from "../../../../operator-subcontractors-detail-edite/components/forms-wraper/helpers/required-info";
import { SuccessMessage } from "../../../../operator-subcontractors-detail-edite/components/forms-wraper/helpers/success-message";
import { PutWarehousesUpdateRequestBody } from "../../../../../../services/warehouses/update/types";
import { putWarehousesUpdate } from "../../../../../../services/warehouses/update";
import { useEffect, useState } from "react";
import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { addressVoivodeshipsList } from "../../../../../../helpers/voievodeshipsList";
import { percentageArea } from "../../../../../../utils/regex";
import FormFieldInfo from "../../../../../common-views/offer-form/components/form-field-info/form-field-info";
import { getAllWarehouses } from "../../../../../../services/warehouses/get-all";
import { GetAllWarehouses } from "../../../../../../services/warehouses/get-all/types";

export interface FormWarehousesData {
    id_magazyn: string,
    kod_magazynu: string,
    opis: string,
    powierzchnia_procentowa: number,
    klasa_magazynu: number,
    medyczny: boolean | null,
    adres_id: string,
}

interface WarehousesDataEditeProps {
    warehouses_data: FormWarehousesData,
    handleClose: () => void;
    setWarehouses: (element: GetAllWarehouses[]) => void;
}

type WarehousesDataEditeTestedValue = {
    klasa_magazynu: number,
    kod_magazynu: string,
    medyczny: boolean | null,
    opis: string,
    powierzchnia_procentowa: number,
};


export const WarehousesDataEdite = (
    {
        warehouses_data,
        handleClose,
        setWarehouses,

    }: WarehousesDataEditeProps) => {
    const [openSuccessInfo, setOpenSuccessInfo] = useState(false);
    const [storageClass, setStorageClass] = useState(`${warehouses_data.klasa_magazynu}`);
    const [isMedical, setIsMedical] = useState(`${warehouses_data.medyczny ? 0 : 1}`);

    //Weryfikacja zmiany danych o wyslaniu

    const [storageClassCopy, setStorageClassCopy] = useState(storageClass);
    const [isMedicalCopy, setIsMedicalCopy] = useState(isMedical);

    const startedFormValues: WarehousesDataEditeTestedValue = {
        klasa_magazynu: warehouses_data.klasa_magazynu,
        kod_magazynu: warehouses_data.kod_magazynu,
        medyczny: warehouses_data.medyczny,
        opis: warehouses_data.opis,
        powierzchnia_procentowa: warehouses_data.powierzchnia_procentowa,
    }

    const [startedValues, setStartedValues] = useState(startedFormValues);
    const [isDataChange, setIsDataChange] = useState(false);


    const compareValuesInFormWithStartedValues = (values: WarehousesDataEditeTestedValue, newValues: WarehousesDataEditeTestedValue) => {
        return !shallowEqual(values, newValues);
    }
    //end

    const handleClick = () => {
        setOpenSuccessInfo(true);
    };
    const handleResetStartValueInForm = () => {
        setIsDataChange(false);
    }
    const handleChangeStorageClass = (event: SelectChangeEvent) => {
        setStorageClass(event.target.value as string);

    };
    const handleChangeIsMedical = (event: SelectChangeEvent) => {
        setIsMedical(event.target.value as string);
    };

    const reGetAllWarehouses = useMutation(getAllWarehouses, {
        onSuccess: (data) => {
            setWarehouses(data.data.payload.magazyny);
        },
    });

    const editWarehousesDataMutation = useMutation(putWarehousesUpdate, {

        onSuccess: (res) => {
            reGetAllWarehouses.mutate({
                paginacja: null,
            })

            setStorageClassCopy(storageClass);
            setIsMedicalCopy(isMedical);
            setStartedValues({
                klasa_magazynu: Number(storageClass),
                kod_magazynu: formik.values.kod_magazynu,
                medyczny: isMedical === "0" ? true : false,
                opis: formik.values.opis,
                powierzchnia_procentowa: Number(formik.values.powierzchnia_procentowa),
            });
            setIsDataChange(false);
            handleClick();//InfoSuccess
        },
    });


    const validationSchema = yup.object({
        kod_magazynu: yup
            .string()
            .required("Kod magazynu jest wymagany"),
        opis: yup
            .string()
            .nullable(true),
        powierzchnia_procentowa: yup
            .string()
            .matches(/^[0-9]$|^[1-9][0-9]$|^(100)$|^([0-9]){1}(\.[0-9]{1,2})?$|^([1-9][0-9])(\.[0-9]{1,2})?$/, "Błędny format danych!"),
    });


    const formik = useFormik({
        initialValues: {
            id_magazyn: warehouses_data.id_magazyn,
            kod_magazynu: warehouses_data.kod_magazynu,
            opis: warehouses_data.opis,
            powierzchnia_procentowa: warehouses_data.powierzchnia_procentowa,
            klasa_magazynu: Number(storageClass),
            medyczny: Number(isMedical) === 0 ? true : false,
            adres_id: warehouses_data.adres_id,
        },
        validationSchema: validationSchema,

        onSubmit: (values: PutWarehousesUpdateRequestBody) => {

            setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                klasa_magazynu: Number(storageClass),
                kod_magazynu: formik.values.kod_magazynu,
                medyczny: isMedical === "0" ? true : false,
                opis: formik.values.opis,
                powierzchnia_procentowa: Number(formik.values.powierzchnia_procentowa),
            }));

            const body = {
                id_magazyn: formik.values.id_magazyn,
                kod_magazynu: formik.values.kod_magazynu,
                opis: formik.values.opis,
                powierzchnia_procentowa: Number(formik.values.powierzchnia_procentowa),
                klasa_magazynu: Number(storageClass),
                medyczny: isMedical === "0" ? true : false,
                adres_id: formik.values.adres_id,
            }

            if (isDataChange) {
                editWarehousesDataMutation.mutate(body)
            }
        },
    });

    useEffect(() => {
        setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
            klasa_magazynu: Number(storageClass),
            kod_magazynu: formik.values.kod_magazynu,
            medyczny: isMedical === "0" ? true : false,
            opis: formik.values.opis,
            powierzchnia_procentowa: Number(formik.values.powierzchnia_procentowa),
        }))

    }, [formik.values, isDataChange]);


    useEffect(() => {
        setIsDataChange(!(isMedical === isMedicalCopy));
    }, [isMedical]);

    useEffect(() => {
        setIsDataChange(!(storageClassCopy === storageClass));
    }, [storageClass]);

    return (
        <Container>
            <form

                onSubmit={formik.handleSubmit}
                onChange={() => setIsDataChange(compareValuesInFormWithStartedValues(startedValues, {
                    klasa_magazynu: Number(storageClass),
                    kod_magazynu: formik.values.kod_magazynu,
                    medyczny: isMedical === "0" ? true : false,
                    opis: formik.values.opis,
                    powierzchnia_procentowa: Number(formik.values.powierzchnia_procentowa),
                }))
                }
            >
                <SumamryWraper key="kod_magazynu">
                    <SummaryItemValue>
                        <Input
                            label="Kod magazynu*"
                            id="kod_magazynu"
                            name="kod_magazynu"
                            value={formik.values.kod_magazynu}
                            onChange={formik.handleChange}
                            error={formik.touched.kod_magazynu && Boolean(formik.errors.kod_magazynu)}
                            helperText={formik.touched.kod_magazynu && formik.errors.kod_magazynu}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="opis">
                    <SummaryItemValue>
                        <Input
                            label="Opis"
                            id="opis"
                            name="opis"
                            value={formik.values.opis}
                            onChange={formik.handleChange}
                            error={formik.touched.opis && Boolean(formik.errors.opis)}
                            helperText={formik.touched.opis && formik.errors.opis}
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                <SumamryWraper key="powierzchnia_procentowa">
                    <SummaryItemValue>
                        <Input
                            label="Powierzchnia procentowa"
                            id="powierzchnia_procentowa"
                            name="powierzchnia_procentowa"
                            value={formik.values.powierzchnia_procentowa}
                            onChange={formik.handleChange}
                            error={formik.touched.powierzchnia_procentowa && Boolean(formik.errors.powierzchnia_procentowa)}
                            helperText={
                                formik.touched.powierzchnia_procentowa
                                &&
                                formik.errors.powierzchnia_procentowa
                            }
                            onBlur={formik.handleBlur}
                            variant="filled"
                            sx={{
                                width: "100%",
                                textOverflow: "ellipsis",
                            }}
                        />
                    </SummaryItemValue>
                </SumamryWraper>
                < SumamryWraper key="klasa_magazynu" style={{ top: "25px", marginTop: "-16px" }}>
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "100000",

                        }}
                        >Klasa magazynu*
                        </InputLabel>
                        <Select
                            name="klasa_magazynu"
                            id="klasa_magazynu"
                            value={storageClass}
                            onChange={handleChangeStorageClass}
                            variant="filled"
                            disableUnderline
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",


                                "& .MuiFilledInput-root": {
                                    color: `${theme.colors.black_primaryText} `,
                                    overflow: "hidden",
                                    borderRadius: 10,
                                    backgroundColor: "#fcfcfb",
                                    border: "none",

                                    "&:hover": {
                                        backgroundColor: `${theme.colors.white} `,

                                    },
                                    "&.Mui-focused": {
                                        backgroundColor: `${theme.colors.gray05_input} `,
                                        boxShadow: `rgba(25, 18, 210, 0.25) 0 0 0 2px`,
                                        borderColor: `${theme.colors.blue01_active} `,
                                    },
                                },
                                "& .MuiFormLabel-root": {

                                    "&.Mui-focused": {
                                        color: `${theme.colors.gray01_secondaryText} `,

                                    },
                                },
                                "& .Mui-error": {
                                    color: `${theme.colors.red01_alert} `,
                                    // "font-size": "12px",//<<<TODO
                                }
                            }}
                        >
                            <MenuItem value={'0'} >A++</MenuItem>
                            <MenuItem value={'1'} >A+</MenuItem>
                            <MenuItem value={'2'} >A</MenuItem>
                            <MenuItem value={'3'} >B</MenuItem>
                        </Select>
                    </SummaryItemValue>
                </SumamryWraper >
                < SumamryWraper key="medyczny" style={{ top: "25px", marginTop: "-16px" }}>
                    <SummaryItemValue>
                        <InputLabel sx={{
                            color: `${theme.colors.gray01_secondaryText}`,
                            fontSize: "12px",
                            font: `${theme.fonts.interRegular}`,
                            top: "25px",
                            left: "12px",
                            zIndex: "100000",

                        }}
                        >Medyczny*
                        </InputLabel>
                        <Select
                            name="medyczny"
                            id="medyczny"
                            value={isMedical}
                            onChange={handleChangeIsMedical}
                            variant="filled"
                            disableUnderline
                            sx={{
                                width: "100%",
                                backgroundColor: "#fcfcfb",
                                borderRadius: "8px",


                                "& .MuiFilledInput-root": {
                                    color: `${theme.colors.black_primaryText} `,
                                    overflow: "hidden",
                                    borderRadius: 10,
                                    backgroundColor: "#fcfcfb",
                                    border: "none",

                                    "&:hover": {
                                        backgroundColor: `${theme.colors.white} `,

                                    },
                                    "&.Mui-focused": {
                                        backgroundColor: `${theme.colors.gray05_input} `,
                                        boxShadow: `rgba(25, 18, 210, 0.25) 0 0 0 2px`,
                                        borderColor: `${theme.colors.blue01_active} `,
                                    },
                                },
                                "& .MuiFormLabel-root": {

                                    "&.Mui-focused": {
                                        color: `${theme.colors.gray01_secondaryText} `,

                                    },
                                },
                                "& .Mui-error": {
                                    color: `${theme.colors.red01_alert} `,
                                    // "font-size": "12px",//<<<TODO
                                }
                            }}
                        >
                            <MenuItem value={'0'} >Tak</MenuItem>
                            <MenuItem value={'1'} >Nie</MenuItem>

                        </Select>
                    </SummaryItemValue>
                </SumamryWraper >
                < RequiredInfo text={"Pola wymagane"} />
                < SuccessMessage
                    message={"Dane magazynu zostały zmienione"}
                    setOpenSuccessInfo={setOpenSuccessInfo}
                    openSuccessInfo={openSuccessInfo}
                />
                <ButtonWraper>
                    <StyledButton
                        type="submit"
                        variant="contained"
                        sx={{
                            marginTop: "16px",
                            marginBottom: "16px",
                            marginLeft: "auto",
                            width: "150px",
                        }}
                        disabled={!isDataChange || editWarehousesDataMutation.isLoading || !formik.isValid}
                    >
                        Zapisz
                    </StyledButton>
                </ButtonWraper>
            </form >
        </Container >
    );
};
const Container = styled.div`
width:100%;
font-family:${theme.fonts.interMedium},
`
const SumamryWraper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
`;

const SummaryItemValue = styled.div`
padding: 5px 0px;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
overflow-wrap: break-word;
align-content: center;
white-space: break-spaces;
`;

const ButtonWraper = styled.div`
width:100%;
text-align:center;`
function getMagazineClassFromEnum(klasa_magazynu: number) {
    throw new Error("Function not implemented.");
}

